import { ReactNode, useLayoutEffect } from "react";

const PageLayout = ({ children }: { children: ReactNode }) => {
  // This runs immediately when the layout mounts
  useLayoutEffect(() => {
    // 1. Disable browser's "memory" of the scroll position
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    // 2. Force scroll to top instantly
    window.scrollTo(0, 0);
    
    // 3. Backup for specific CSS/Browser behaviors
    document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, []);

  return (
    <main className="min-h-screen bg-background pt-24 pb-16 px-6">
      {children}
    </main>
  );
};

export default PageLayout;